import { Injectable, inject } from "@angular/core";
import { ProcessResource } from "core/stages-client";

@Injectable({ providedIn: "root" })
export class ResetTailoringService {
	private processResource = inject(ProcessResource);

	async reset(workspaceId: string, pv: string): Promise<void> {
		return this.processResource.reset(workspaceId, {
			pv: pv,
		});
	}
}
